import gql from "graphql-tag";
import {
  GetBuildings_buildingConnections_buildings as BuildingsDataGenerated,
  GetBuildings as GetBuildingsGenerated,
  GetBuildingsVariables as GetBuildingsVariablesGenerated,
} from "core/queries/__generated__/GetBuildings";

// Queries
export interface BuildingsData extends BuildingsDataGenerated {}
export interface GetBuildingsResponse extends GetBuildingsGenerated {}
export interface GetBuildingsVariables extends GetBuildingsVariablesGenerated {}
export interface CheckedBuildingsData extends BuildingsData {
  isChecked: boolean;
}

// Note, this query is very naive. As more and more buildings are added to cities, we should revisit this.
export const getBuildings = gql`
  query GetBuildings($activeOnly: Boolean = true, $city: ID) {
    buildingConnections(filter: { activeOnly: $activeOnly, city: $city }) {
      buildings {
        id
        internalRef
        name
      }
    }
  }
`;
